import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../utils/colors';
import ScrollIndicator from './shared/ScrollIndicator';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const AnchorPage = () => {
  // Use our custom hook to apply random colors to all links
  useRandomLinkColors();
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/xqEQwXbffHUxVi3kwyfNjn/MM-1.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/w56kQPkvAcEvMAVTpeWa5Z/MM-2.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/jdzxqdFSPG5avdocbVpB7v/MM-3.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/dkMYsFcrhXFBcrTeDGbLGP/MM-4.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/dTsY2vJ6yZfw4HWUKcYn3u/MM-5.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/iaKJF9uBtZrSj7WpBLT747/MM-7.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/qwsLXnKhTHpmSZCRrfNehg/MM-8.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/pP3sjXdgkXTpWwDUBxXNuF/MM-9.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/fWDD3PdHLh3cryfECBUeVW/MM-10.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/uDhynwd5RR9EBt62UR4LSe/MM-11.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/5H93J9DabHcJ4pqsTct4s6/MM-12.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/mosfUjnAdEKgX1YAojMsSM/MM-13.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/43td1cd7rGiZkG67DVkUjJ/MM-14.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/dAHMmRRjWFAK97aVwgDh3e/MM-15.jpg'];
  const getSpacing = index => {
    const spacings = [6, 12, 8, 16, 10, 14, 7, 12, 9, 16, 10, 14];
    return spacings[index % spacings.length];
  };
  const getHeight = index => {
    const heights = ['70vh', '65vh', '75vh', '68vh'];
    return heights[index % heights.length];
  };
  const getImagePosition = (index: number) => {
    if (index === 0) return '16vh';
    const positions = ['12vh', '28vh', '4vh', '20vh', '8vh', '24vh', '16vh'];
    return positions[index % positions.length];
  };
  const getImageSize = (index: number) => {
    if (index === 0) return '70vh';
    const sizes = ['85vh', '70vh', '75vh', '65vh', '80vh'];
    return sizes[index % sizes.length];
  };
  const handleAudioClick = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      } else {
        audioRef.current.play().catch(err => console.log('Audio playback prevented'));
      }
      setIsPlaying(!isPlaying);
    }
  };
  useEffect(() => {
    const container = containerRef.current;
    const audio = audioRef.current;
    // Remove scroll handler - audio should only play on button click
    return () => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    };
  }, []);
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-43">
      <header className="fixed top-0 w-full flex justify-end px-6 py-6 z-10 bg-[#faf9f7]" data-id="element-44">
        <div className="flex space-x-6" data-id="element-45">
          <div className="text-base font-normal" data-id="element-46">
            <Link to="/" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-47">
              Madeleine Morlet
            </Link>
          </div>
          <div className="text-base font-normal" data-id="element-48">
            <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-49">
              Info
            </Link>
          </div>
        </div>
      </header>
      <audio ref={audioRef} src="https://bucket-riljmu.s3.eu-west-2.amazonaws.com/Anchor%20Audio%20Clip%20(2015).wav" preload="auto" className="hidden" data-id="element-50" />
      {/* Desktop Layout */}
      <div className="hidden md:block h-screen overflow-x-auto hide-scrollbar" data-id="element-51">
        <div className="flex min-w-max" data-id="element-52">
          <div className="w-[33vw] pl-16 flex-shrink-0" style={{
          paddingTop: '24vh'
        }} data-id="element-53">
            <div className="text-base max-w-[360px] pr-4" data-id="element-54">
              <div data-id="element-55">Anchor (2015)</div>
              <div className="text-sm leading-relaxed mt-4" data-id="element-56">
                <em data-id="element-57">Anchor</em> is a short film that explores the concept of
                photographic stills in motion. It visually references a series
                of images taken between 2013 and 2014 with a Nikon AD
                point-and-shoot camera. The sound design by Johnnie Burn is
                emphasised to create a sense of movement between each frame.
              </div>
              <button onClick={handleAudioClick} className="text-sm leading-normal transition-colors duration-200" data-color-applied="false" data-id="element-58">
                {isPlaying ? 'Stop audio clip' : '*Play audio clip'}
              </button>
            </div>
          </div>
          <div ref={containerRef} className="flex items-start" style={{
          paddingTop: '16vh'
        }} data-id="element-59">
            {images.map((image, index) => <div key={index} className="flex-shrink-0" style={{
            marginRight: index === images.length - 1 ? 0 : `${getSpacing(index)}rem`
          }} data-id="element-60">
                <img src={image} alt={`Anchor - Image ${index + 1}`} className="w-auto object-contain" style={{
              height: getImageSize(index)
            }} data-id="element-61" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Mobile Layout */}
      <div className="md:hidden pt-20 px-6" data-id="element-62">
        <div className="mb-6" data-id="element-63">
          <div className="text-base mb-4" data-id="element-64">Anchor (2015)</div>
          <div className="text-sm leading-normal mb-4" data-id="element-65">
            <em data-id="element-66">Anchor</em> is a short film that explores the concept of
            photographic stills in motion. It visually references a series of
            images taken between 2013 and 2014 with a Nikon AD point-and-shoot
            camera. The sound design by Johnnie Burn is emphasised to create a
            sense of movement between each frame.
          </div>
          <button onClick={handleAudioClick} className="text-sm leading-normal transition-colors duration-200" data-id="element-67">
            {isPlaying ? 'Stop audio clip' : '*Play audio clip'}
          </button>
        </div>
        <div className="w-full space-y-8" data-id="element-68">
          {images.map((image, index) => <div key={index} className="w-full" data-id="element-69">
              <img src={image} alt={`Anchor - Image ${index + 1}`} className="w-full h-auto object-contain" data-id="element-70" />
            </div>)}
        </div>
      </div>
      <ScrollIndicator data-id="element-71" />
      <style jsx data-id="element-72">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};
export default AnchorPage;